import { dailyRevealProductName } from './dailyRevealProductName';

/** "Gridiron Draw 9/21" — product name + contest day, matching the My Games mock. */
export function formatDailyRevealContestTitle(
  sport: string | null | undefined,
  gameDate: string
): string {
  const product = dailyRevealProductName(sport);
  const d = new Date(gameDate + 'T12:00:00');
  if (Number.isNaN(d.getTime())) return product;
  const monthDay = `${d.getMonth() + 1}/${d.getDate()}`;
  return `${product} ${monthDay}`;
}
